import { render, staticRenderFns } from "./PopUpTicketFile.vue?vue&type=template&id=b43e0228&scoped=true&"
import script from "./PopUpTicketFile.vue?vue&type=script&lang=js&"
export * from "./PopUpTicketFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b43e0228",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b43e0228')) {
      api.createRecord('b43e0228', component.options)
    } else {
      api.reload('b43e0228', component.options)
    }
    module.hot.accept("./PopUpTicketFile.vue?vue&type=template&id=b43e0228&scoped=true&", function () {
      api.rerender('b43e0228', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/vistas/modals/PopUpTicketFile.vue"
export default component.exports